var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IBM-Runbooks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-3539.000000, -2062.000000)",
    fill: "#FFD33A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3556.675,2078.2 L3548.55,2062.575 C3548.4409,2062.37286 3548.2297,2062.24686 3548,2062.24686 C3547.7703,2062.24686 3547.5591,2062.37286 3547.45,2062.575 L3539.325,2078.2 C3539.21335,2078.39338 3539.21335,2078.63162 3539.325,2078.825 C3539.44136,2079.0163 3539.65116,2079.13074 3539.875,2079.125 L3556.125,2079.125 C3556.34567,2079.12496 3556.54996,2079.00856 3556.6625,2078.81875 C3556.77566,2078.62918 3556.78041,2078.39398 3556.675,2078.2 Z M3547.3,2067.25 L3548.70625,2067.25 L3548.70625,2073.5 L3547.3,2073.5 L3547.3,2067.25 Z M3548,2077.25 C3547.48223,2077.25 3547.0625,2076.83027 3547.0625,2076.3125 C3547.0625,2075.79473 3547.48223,2075.375 3548,2075.375 C3548.51777,2075.375 3548.9375,2075.79473 3548.9375,2076.3125 C3548.9375,2076.83027 3548.51777,2077.25 3548,2077.25 Z",
    id: "Fill"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.00c14208e6448ddce7174da6df82c5b4.svg";
export { ForwardRef as ReactComponent };